/**
 * Contains
 * */
export default class State
{
	static INITIAL = 'INITIAL';
	static DATA_INPUTTING = 'DATA_INPUTTING';
	static DATA_SELECTED = 'DATA_SELECTED';
	static DATA_SUPPOSED = 'DATA_SUPPOSED';
	static DATA_LOADING = 'DATA_LOADING';
	static DATA_LOADED = 'DATA_LOADED';
}